const state = {
    perplexityPopShow: false,
    perplexityTransactionKey: null,
    productEmail: null
};

const getters = {
    perplexityPopShow: (state) => state.perplexityPopShow,
    perplexityTransactionKey: (state) => state.perplexityTransactionKey,
    productEmail: (state) => state.productEmail
};

const mutations = {
    setPerplexityPopShow(state, showValue) {
        state.perplexityPopShow = showValue;
    },
    setPerplexityTransactionKey(state, transactionKey) {
        state.perplexityTransactionKey = transactionKey;
    },
    setPerplexityProductEmail(state, email) {
        state.productEmail = email;
    }
};

const actions = {
    updatePerplexityPopShow({ commit }, showValue) {
        commit('setPerplexityPopShow', showValue);
    },
    updatePerplexityTransactionKey({ commit }, transactionKey) {
        commit('setPerplexityTransactionKey', transactionKey);
    },
    updatePerplexityProductEmail({ commit }, email) {
        commit('setPerplexityProductEmail', email);
    }
};

export default {
    namespaced: true, // 使用命名空间
    state,
    getters,
    mutations,
    actions,
}; 